import { apiClient } from "../../../lib";

export const riskDetailsApi = {
    fetchRiskDetail: async ({ riskId }: { riskId: string | null }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}`);
        return response.data;
    },
    fetchRiskSummary: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/summary' : `/risks/summary?project_id=${projectId}`);
        return response.data;
    },
    fetchCriticalRisks: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/critical-risk' : `/risks/critical-risk?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskCategories: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/risk-categories' : `/risks/risk-categories?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskMatrix: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/risk-matrix' : `/risks/risk-matrix?project_id=${projectId}`);
        return response.data;
    },
    fetchRiskRegister: async ({ projectId, searchKey }: { projectId: string | undefined, searchKey: string }): Promise<any> => {
        // const response = await apiClient.get(!projectId ? '/risks/risk-register' : `/risks/risk-register?project_id=${projectId}&search_term=${searchKey}`);
        const response = await apiClient.get('/risks/risk-register', {
            params: {
                project_id: projectId,
                search_term: searchKey
            }
        });
        return response.data;
    },
};